export type Decimal = number;
export type String = string;

export enum IsSameAddress {
  YES = "YES",
  NO = "NO",
}

export enum IsDeliveryToAddress {
  YES = "YES",
  NO = "NO",
}

export enum CountryCode {
  NL = "Nederland",
  BG = "België",
}

export enum IsSignUp {
  YES = "YES",
  NO = "NO",
}

export enum Checkbox {
  YES = "YES",
}

export interface Money {
  value: Decimal;
  currencyCode: String;
}

export enum CheckoutActions {
  SET_ADDRESS_AS_GUEST = "SET_ADDRESS_AS_GUEST",
  CREATE_ORDER = "CREATE_ORDER",
  SET_DELIVERY_OPTION = "SET_DELIVERY_OPTION",
  SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD",
  ADD_COUPON = "ADD_COUPON",
  DELETE_COUPON = "DELETE_COUPON",
  ABANDON_CART = "ABANDON_CART",
}

export enum ContactUsAction {
  CONTACT_US = "CONTACT_US",
}

export enum NotifyMeAction {
  NOTIFY_ME = "NOTIFY_ME",
}
